module.exports = __webpack_public_path__ + "static/media/unknown.b3068b38.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/weather-icons/unknown.svg
// module id = 533
// module chunks = 0